import React from 'react';
import Svg from '../Svg';

interface IMapMarketAltIconProps {
  children?: React.ReactNode;
  className: string;
}

export default function MapMarketAltIcon(
  props: IMapMarketAltIconProps,
): JSX.Element {
  return (
    <Svg width="11" height="11" viewBox="0 0 384 512" fill="none" {...props}>
      <path
        fill="#4d4048"
        d="M192 96c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64zm0-256C85.961 0 0 85.961 0 192c0 77.413 26.97 99.031 172.268 309.67 9.534 13.772 29.929 13.774 39.465 0C357.03 291.031 384 269.413 384 192 384 85.961 298.039 0 192 0zm0 473.931C52.705 272.488 32 256.494 32 192c0-42.738 16.643-82.917 46.863-113.137S149.262 32 192 32s82.917 16.643 113.137 46.863S352 149.262 352 192c0 64.49-20.692 80.47-160 281.931z"
      />
    </Svg>
  );
}
